import * as angular from "angular";
import {Settelment} from "../models/settelment.model";
import {IPromise, IQService} from "angular";
import {ContractsRequestsService} from "./contracts-requests.service";
import {ContractAlertsService} from "./contract-alerts.service";
import {BringozLoaderService} from "../../commons/services/bringoz-loader.service";

export class ContractsService {
  constructor(private contractsRequestsService: ContractsRequestsService, private contractAlertsService: ContractAlertsService,
              private bringozLoaderService: BringozLoaderService, private $q: IQService, private $log) {
  }

  createNewContract(contractName: string, settlementsArray: Settelment[], accountId?: string) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.contractsRequestsService.createNewContract(contractName, settlementsArray, accountId)
      .then((contract) => {
        this.contractAlertsService.createSuccess();
        deferred.resolve(contract);
      })
      .catch((error) => {
        this.$log.error(error);
        this.contractAlertsService.createError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  updateContractName(contractId: string, newName: string) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.contractsRequestsService.updateOne(contractId, newName)
      .then((contract) => {
        this.contractAlertsService.updateSuccess();
        deferred.resolve(contract);
      })
      .catch((error) => {
        this.$log.error(error);
        this.contractAlertsService.createError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  deleteContract(contractId: string) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.contractsRequestsService.deleteContract(contractId)
      .then(() => {
        this.contractAlertsService.deleteSuccess();
        deferred.resolve(contractId);
      })
      .catch((error) => {
        this.$log.error(error);
        this.contractAlertsService.deleteError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  assignAccounts(contractId: string, payload: { ids?: string[], excludedIds?: string[] }): IPromise<any> {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.contractsRequestsService.assignAccounts(contractId, payload)
      .then((contract) => {
        this.contractAlertsService.assignSuccess();
        deferred.resolve(contract);
      })
      .catch((error) => {
        this.$log.error(error);
        this.contractAlertsService.assignError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  removeAccounts(contractId: string, accountIds: string[]): IPromise<any> {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.contractsRequestsService.removeAccounts(contractId, accountIds)
      .then((contract) => {
        this.contractAlertsService.removeAccountSuccess();
        deferred.resolve(contract);
      })
      .catch((error) => {
        this.$log.error(error);
        this.contractAlertsService.removeAccountError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  addNewProgramToContract(contractId: string, program: any) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.contractsRequestsService.addNewProgramToContract(contractId, program)
      .then((contract) => {
        this.contractAlertsService.addSettelmentSuccess();
        deferred.resolve(contract);
      })
      .catch((error) => {
        this.$log.error(error);
        this.contractAlertsService.addSettelmentError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  removeProgramFromContract(contractId: string, programType: string) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.contractsRequestsService.removeProgramFromContract(contractId, programType)
      .then((contract) => {
        this.contractAlertsService.removeProgramFromContractSuccess();
        deferred.resolve(contract);
      })
      .catch((error) => {
        this.$log.error(error);
        this.contractAlertsService.removeProgramFromContractError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  setAsDefault(contractId: string) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.contractsRequestsService.setAsDefault(contractId)
      .then(() => {
        this.contractAlertsService.setAsDefaultSuccess();
        deferred.resolve(contractId);
      })
      .catch((error) => {
        this.contractAlertsService.setAsDefaultError();
        this.$log.error(error);
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }


}

angular
  .module('bringoz.admin.contracts')
  .service('contractsService', ContractsService);
